export const crmEn = {
  addProject: 'Add CRM-project',
  newProjectTitle: 'New CRM-project',
  dealAmountStickerTitle: 'Deals amount',
  newDealPopupTitle: 'Add deal',
  contactPerson: 'Contact person',
  contactPersons: 'Contact persons',
  organization: 'Organization',
  organizations: 'Organizations',
  dealTitle: 'Deal title',
  dealBadge: 'Deal',
  unlinkFromDeal: 'Unlink from deal',
  newDealForm: {
    enterAmountPlaceholder: 'Enter amount',
    enterTitlePlaceholder: 'Enter title',
    addAsNewContactPersonLabel: (value: string) =>
      `Add "${value}" as new contact`,
    addAsNewOrganizationLabel: (value: string) =>
      `Add "${value}" as new organization`
  },
  dealTitleAutofill: (value: string) => `${value} deal`,
  analytics: {
    buttonTimeline: 'Analytics',
    viewHint: 'Show analytics',
    tableHeader: 'Sales conversion funnel',
    overallConversion: 'Total conversion rate:',
    overallDenial: 'Percentage of rejection:',
    overallInWork: 'Percentage of transactions in progress',
    totalCounts: 'Total transactions',
    noData: 'No data available for the current period',
    stageColTable: 'Stage',
    conversionColTable: 'Conversion',
    countsColTable: 'Number of deals',
    successRate: 'Success rate',
    rejectedRate: 'Rejected rate',
    wipTitle: 'A section in development',
    wipSubTitle: 'There will be more useful reports here soon',
    dealCreatedAtStickerTitle: 'Filter by creation date',
    dateRange: 'Date range',
    clearFilter: 'Clear filter',
    creationDate: 'Creation date',
    filterHint: 'Select a date range to filter'
  },
  activities: {
    boardViewLabel: 'Activities',
    viewHint: 'Show activities'
  },
  board: {
    title: 'Sales',
    inboxColumnTitle: 'First touch',
    offerColumnTitle: 'Commercial offer',
    paymentColumnTitle: 'Pending payment',
    succeededColumnTitle: '✅ Succeeded',
    rejectedColumnTitle: '❌ Rejected',
    addDealActivity: 'Add activity'
  },
  activitiesView: {
    filterByAssigned: 'Filter by assigned',
    tabs: {
      day: 'Plans for the day',
      failed: 'Overdue',
      completed: 'Completed'
    },
    table: {
      done: 'DONE',
      activity: 'ACTIVITY',
      task: 'TASK',
      company: 'COMPANY',
      deadline: 'DATE',
      contactPerson: 'CONTACT PERSON',
      phone: 'PHONE',
      email: 'EMAIL'
    },
    emptyRowsPlaceholder: {
      title: 'No activities found',
      subtitle:
        'No activities found for the selected assignee. Please select another assignee.'
    },
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow'
  },
  rightPanel: {
    dealHistory: {
      deal: 'Deal',
      note: 'Note',
      deals: 'Deals',
      markActivityCompleted: 'Mark completed',
      markActivityUncompleted: `Mark uncompleted`,
      title: 'Deal history',
      dealCreated: 'deal created',
      dealMoved: 'moved',
      placeholderNote: 'Enter a comment',
      placeholderDeal: 'Enter name',
      create: 'Create',
      noMsg: 'There will be a history of the deal, comments and cases',
      deleteActivity: 'Delete activity',
      deleteActivityConfirmation:
        'Are you sure you want to delete this activity?',
      deleteNoteActivity: 'Delete note',
      deleteNoteActivityConfirmation:
        'Are you sure you want to delete this note?'
    },
    organization: {
      title: 'Company',
      name: 'Name'
    },
    contactPerson: {
      important: 'Important',
      title: 'About the client',
      manager: 'Responsible manager',
      contact: 'Contact person',
      name: 'Name',
      phone: 'Phone',
      email: 'E-mail',
      position: 'Position',
      organizationName: 'Name',
      website: 'Website',
      address: 'Address'
    }
  },
  boardSettings: {
    customFields: 'Custom fields',
    settingsCustomFields: 'Custom field settings',
    addNewField: 'Add field',
    fieldName: 'Field name',
    fieldType: 'Field type',
    settingCustomField: 'Settings custom field',
    notEmptyField: 'Field cannot be empty',
    fieldsUpdated: 'Fields have been updated successfully',
    customFieldsType: {
      string: 'Text',
      number: 'Number',
      email: 'Email',
      url: 'Link'
    }
  }
}

export const crmRu: typeof crmEn = {
  addProject: 'Добавить CRM-проект',
  newProjectTitle: 'Новый CRM-проект',
  dealAmountStickerTitle: 'Сумма сделки',
  newDealPopupTitle: 'Добавить сделку',
  contactPerson: 'Контактное лицо',
  contactPersons: 'Контактные лица',
  organization: 'Компания',
  organizations: 'Компании',
  dealTitle: 'Название сделки',
  dealBadge: 'Сделка',
  unlinkFromDeal: 'Открепить от сделки',
  newDealForm: {
    enterAmountPlaceholder: 'Введите сумму',
    enterTitlePlaceholder: 'Введите название',
    addAsNewContactPersonLabel: (value: string) =>
      `Добавить «${value}» как новый контакт`,
    addAsNewOrganizationLabel: (value: string) =>
      `Добавить «${value}» как новую компанию`
  },
  dealTitleAutofill: (value: string) => `Сделка с ${value}`,
  analytics: {
    buttonTimeline: 'Аналитика',
    viewHint: 'Показать аналитику',
    tableHeader: 'Конверсионная воронка продаж',
    overallConversion: 'Общая конверсия',
    overallDenial: 'Процент отказов',
    overallInWork: 'Процент сделок в работе',
    totalCounts: 'Всего сделок',
    noData: 'Нет данных за текущий период',
    stageColTable: 'Этап',
    conversionColTable: 'Конверсия',
    countsColTable: 'Количество сделок',
    successRate: 'Процент успешных',
    rejectedRate: 'Процент отказов',
    wipTitle: 'Раздел в разработке',
    wipSubTitle: 'Скоро тут будет больше полезной аналитики',
    dealCreatedAtStickerTitle: 'Фильтр по дате создания',
    dateRange: 'Диапазон дат',
    clearFilter: 'Очистить фильтр',
    creationDate: 'Дата создания',
    filterHint: 'Выберите диапазон дат для фильтрации'
  },
  activities: {
    boardViewLabel: 'Дела',
    viewHint: 'Показать дела'
  },
  board: {
    title: 'Продажи',
    inboxColumnTitle: 'Первое касание',
    offerColumnTitle: 'Коммерческое предложение',
    paymentColumnTitle: 'Ожидание оплаты',
    succeededColumnTitle: '✅ Успешные',
    rejectedColumnTitle: '❌ Отказы',
    addDealActivity: 'Добавить дело'
  },
  activitiesView: {
    filterByAssigned: 'Фильтрация по исполнителю',
    tabs: {
      day: 'Планы на день',
      failed: 'Просроченные',
      completed: 'Выполненные'
    },
    table: {
      done: 'СДЕЛАНО',
      activity: 'ДЕЛО',
      company: 'КОМПАНИЯ',
      task: 'СДЕЛКА',
      deadline: 'ДАТА',
      contactPerson: 'КОНТАКТНОЕ ЛИЦО',
      phone: 'ТЕЛЕФОН',
      email: 'ПОЧТА'
    },
    emptyRowsPlaceholder: {
      title: 'Дел не найдено!',
      subtitle: 'Попробуйте сбросить фильтр или переключиться на другой день'
    },
    today: 'Сегодня',
    yesterday: 'Вчера',
    tomorrow: 'Завтра'
  },
  rightPanel: {
    dealHistory: {
      deals: 'Дела',
      deal: 'Дело',
      note: 'Комментарий',
      markActivityCompleted: 'Отметить сделанным',
      markActivityUncompleted: 'Отметить несделанным',
      title: 'История сделки',
      dealMoved: 'перемещена',
      dealCreated: 'сделка создана',
      placeholderNote: 'Введите комментарий',
      placeholderDeal: 'Введите название',
      create: 'Создать',
      noMsg: 'Здесь будут история сделки, комментарии и дела',
      deleteActivity: 'Удалить дело',
      deleteActivityConfirmation: 'Вы уверены, что хотите удалить это дело?',
      deleteNoteActivity: 'Удалить комментарий',
      deleteNoteActivityConfirmation:
        'Вы уверены, что хотите удалить этот комментарий?'
    },
    organization: {
      title: 'Компания',
      name: 'Название'
    },
    contactPerson: {
      important: 'Важное',
      title: 'О клиенте',
      manager: 'Ответственный менеджер',
      contact: 'Контактное лицо',
      name: 'Имя',
      phone: 'Телефон',
      email: 'E-mail',
      position: 'Должность',
      organizationName: 'Название',
      website: 'Сайт',
      address: 'Адрес'
    }
  },
  boardSettings: {
    customFields: 'Пользовательские поля',
    settingsCustomFields: 'Настройки пользовательских полей',
    addNewField: 'Добавить поле',
    fieldName: 'Название поля',
    fieldType: 'Тип поля',
    settingCustomField: 'Настройки пользовательских полей',
    notEmptyField: 'Поле не может быть пустым',
    fieldsUpdated: 'Пользовательские поля успешно обновлены',
    customFieldsType: {
      string: 'Текстовое',
      number: 'Числовое',
      email: 'Почта',
      url: 'Ссылка'
    }
  }
}
